import React from 'react'
import PropTypes from 'prop-types'

const SearchIcon = ({ size = '45', color = 'black' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 46 46"
      fill="none">
      <path
        d="M40.4111 37.3537C40.7566 37.6994 40.9507 38.1682 40.9507 38.657C40.9507 39.1458 40.7566 39.6146 40.4111 39.9602C40.0656 40.3058 39.5971 40.5 39.1085 40.5C38.6199 40.5 38.1514 40.3058 37.8059 39.9602L28.7926 30.955C28.6067 30.7833 28.3697 30.6771 28.1179 30.6525C27.866 30.628 27.613 30.6865 27.3974 30.8191C27.1496 31.0049 26.8897 31.1741 26.6196 31.3256C23.9816 32.8331 20.9205 33.4286 17.9101 33.0201C14.8996 32.6116 12.1077 31.2218 9.96636 29.0658C7.82502 26.9098 6.45367 24.1078 6.06452 21.0934C5.67537 18.079 6.29017 15.0204 7.8137 12.3908C9.33722 9.76118 11.6845 7.70728 14.4924 6.54694C17.3003 5.3866 20.4122 5.18452 23.3464 5.97196C26.2807 6.7594 28.8737 8.49246 30.7243 10.9029C32.5748 13.3134 33.5796 16.2669 33.5833 19.3063C33.5899 21.7262 32.955 24.1047 31.7435 26.1992C31.6055 26.4508 31.4529 26.6941 31.2867 26.928C31.1427 27.1427 31.0754 27.3998 31.0956 27.6576C31.1157 27.9154 31.2222 28.1588 31.3978 28.3486L40.4111 37.3537ZM19.767 29.448C21.7724 29.4504 23.7334 28.8577 25.402 27.7448C27.0707 26.6319 28.3719 25.0489 29.141 23.1959C29.9102 21.343 30.1126 19.3035 29.7229 17.3354C29.3331 15.3673 28.3687 13.559 26.9515 12.1395C25.5343 10.7199 23.7282 9.75278 21.7615 9.36046C19.7948 8.96814 17.756 9.16826 15.903 9.93549C14.05 10.7027 12.4661 12.0026 11.3517 13.6706C10.2373 15.3387 9.64246 17.3 9.64246 19.3063C9.64246 21.9939 10.7088 24.5716 12.6071 26.4732C14.5055 28.3748 17.0807 29.4447 19.767 29.448Z"
        fill={color}
      />
    </svg>
  )
}

export default React.memo(SearchIcon)

SearchIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
}
